import { backendApiClient } from '@geneo2-web/services-clients';

const PATCH_STUDENT_PROFILE_PATH =
  'pal/student_profile.service.v1.StudentProfileService/PatchStudentProfile';

export async function patchStudentProfile(body: {
  firstName: string;
  lastName: string;
}): Promise<void> {
  await backendApiClient.post<void>(PATCH_STUDENT_PROFILE_PATH, body);
}
